import React from 'react';
import { ArcOutlinedInputProps } from './types';
import { TextField } from '@mui/material';

const ArcOutlinedInput = React.forwardRef<HTMLInputElement, ArcOutlinedInputProps>(
  ({ maxLength, value, helperText, error, minNumber, maxNumber, onKeyDown, ...props }, ref) => {

    const length = typeof value === 'string' ? value.length : 0;
    const isOverLimit = maxLength ? length >= maxLength : false;

    const isOutOfRange =
      typeof Number(value) === "number" &&
      ((minNumber !== undefined && Number(value) < minNumber) ||
        (maxNumber !== undefined && Number(value) > maxNumber));

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
      // Safari fix: block non-numeric keys for number inputs
      if (props.type === 'number') {
        const isNumericKey = /^[0-9.-]$/.test(e.key);
        const isControlKey = e.key.length > 1; // Backspace, Delete, Arrow*, Tab, Enter, etc.
        const isShortcut = e.ctrlKey || e.metaKey;
        
        if (!isNumericKey && !isControlKey && !isShortcut) {
          e.preventDefault();
        }
      }
      onKeyDown?.(e);
    };

    return (
      <TextField
        size="small"
        variant="outlined"
        inputRef={ref}
        inputProps={{ 
          maxLength,
          minNumber,
          maxNumber,
        }}
        onKeyDown={handleKeyDown}
        value={value}
        error={error || isOverLimit || isOutOfRange}
        helperText={
          <>
            {helperText || ''}
            {isOutOfRange ? (
              <span style={{ float: 'right' }}>
                The value must be between {minNumber} and {maxNumber}
              </span>
            ) : null}
            {maxLength ? (
              <span style={{ float: 'right', color: isOverLimit ? 'brand.error' : 'inherit' }}>
                {length}/{maxLength}
              </span>
            ) : null}
          </>
        }
        sx={{
          "& .MuiInputLabel-root.Mui-disabled": {
            color: (theme) => theme.palette.ghost.main
          },
          '& .MuiInputBase-input.Mui-disabled': {
            opacity: 1,
            color: (theme) => theme.palette.ghost.main,
            WebkitTextFillColor: (theme) => theme.palette.ghost.main, 
          },
        }}
        {...props}
      />
    );
  }
);

ArcOutlinedInput.displayName = 'ArcOutlinedInput';

export default ArcOutlinedInput;
